import workspaceQuery from '../../queries/supplier/SupplierPriceReviewLineWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SupplierPriceReviewLine: EntityType = {
  type: 'SupplierPriceReviewLine',
  title: 'Supplier Price Review',
  workspaceUrl: '/Supplier/SupplierPriceReviewLineWorkspace/',
  workspace: workspaceQuery,
  screenReference: 'SUPPLIER_PRICE_REVIEW',
};

export default SupplierPriceReviewLine;
